<template>
  <div class="news-warp">
    <div
      style="display: flex; justify-content: space-between; border-radius: 8px"
    >
      <div
        v-infinite-scroll="load"
        style="
          height: calc(100vh - 380px);
          overflow: auto;
          width: 350px;
          background: #fff;
          overscroll-behavior: contain;
          border-radius: 8px;
        "
        infinite-scroll-immediate="false"
        infinite-scroll-disabled="busy"
        infinite-scroll-distance="6"
        class="fn-scrollbar"
      >
        <div vlass="sidePanel">
          <div class="news-warp-tools">
            <div class="timeRange">
              <p>
                <span class="name">文章列表</span>
                <span class="tag">{{ articleTotal }}篇</span>
              </p>
            </div>
            <!-- 排序展示形式 -->
            <div>
              <!-- 时间排序 7天转载排序 -->
              <el-dropdown size="large" @command="handleTime">
                <span class="el-dropdown-link el-dropdown-link-style">
                  {{ timeOrderby }}
                  <i class="el-icon-caret-bottom el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in timeList"
                    :key="index"
                    :command="item.value"
                    :class="{ selected: timeStatus == item.value }"
                    >{{ item.label }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-divider direction="vertical"></el-divider>

              <!-- 查看模式选择 -->
              <el-dropdown size="large" @command="handleShowModel">
                <span class="el-dropdown-link el-dropdown-link-style">
                  {{ textView }}
                  <i class="el-icon-caret-bottom el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in showModelChange"
                    :key="index"
                    :command="item.value"
                    :class="{ selected: modelStatus == item.value }"
                    >{{ item.label }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <article-list
            ref="articleList"
            :showModel="showModel"
            :industryTypeId="formSearch.industryTypeId"
            :articleListData="articleListData"
            @openDetails="openDetails"
          ></article-list>
        </div>

        <div class="feed-m-loading" v-if="loading">
          <span class="text">正在获取更多内容</span>
        </div>
        <div class="noMore" v-if="noMore">没有更多了</div>
        <!-- 相似文章合并提示 -->
        <div class="similarMerger" v-if="similar">
          已加载<span>{{ updateCount }}</span
          >篇文章，其中 <span>{{ combineCount }}</span
          >篇为相似文章，已合并！
        </div>
      </div>
      <!-- 文章详情 -->
      <div v-if="articleTotal > 0" class="articleDetail">
        <article-base
          :articleInfo="articleInfo"
          :analysis="analysis"
        ></article-base>
      </div>
      <div class="articleDetail" v-else>
        <div class="noMore" style="margin-top: 50px">暂无文章</div>
      </div>
    </div>
  </div>
</template>
<script>
import ArticleList from "@/pages/views/project/components/ArticleList.vue";
import ArticleBase from "../project/ArticleBase.vue";
import {
  GetAdvanced,
  GetJfrbArticle,
  GetArticleProperty,
} from "@/api/index.js";
let moment = require("moment"); // 引入moment

export default {
  components: {
    ArticleList,
    ArticleBase,
  },
  props: {
    formSearch: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      combineCount: 0,
      analysis: {},
      showModel: "0",

      textView: "标题查看",
      timeOrderby: "时间降序",
      timeStatus: "0",
      modelStatus: "0",
      timeList: [
        { value: "0", label: "时间降序" },
        { value: "1", label: "时间升序" },
      ],
      showModelChange: [
        { value: "0", label: "标题查看" },
        { value: "1", label: "摘要查看" },
        // { value: "2", label: "列表查看" },
      ],

      currentOrder: "updatetime desc",
      articleTotal: "",
      loading: true,
      noMore: false,
      searchWord: "",
      articleListData: [],
      pageIndexVal: 1,
      pageSizeVal: 300,
      //文章详情
      showDetail: false,
      articleid: "",

      busy: true,
      articleInfo: {},
      similar: false,
    };
  },
  activated() {},
  computed: {
    startTime() {
      return Array.isArray(this.formSearch.time) &&
        this.formSearch.time.length === 2
        ? moment(this.formSearch.time[0]).format("YYYY-MM-DD")
        : "";
    },
    endTime() {
      return Array.isArray(this.formSearch.time) &&
        this.formSearch.time.length === 2
        ? moment(this.formSearch.time[1]).format("YYYY-MM-DD")
        : "";
    },
  },
  watch: {},
  created() {},
  mounted() {
    // this.load();
  },
  methods: {
    getAnalysis(aid) {
      let params = {
        aid: aid,
        absPercent: 0.5,
        aWordCount: 10,
      };
      GetArticleProperty(params)
        .then((res) => {
          this.analysis = res.data;
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    handleShowModel(command) {
      this.modelStatus = command;
      this.showModel = command;
      switch (command) {
        case "0":
          this.textView = "标题查看";
          break;
        case "1":
          this.textView = "摘要查看";
          break;
        case "2":
          this.textView = "列表查看";
          break;
      }
      // this.$store.commit("changModel", command);
    },
    // list显示模式
    listInit() {
      this.showModel = this.ListModelCom;
      this.modelStatus = this.ListModelCom;
      switch (this.showModel) {
        case "0":
          this.textView = "标题查看";
          break;
        case "1":
          this.textView = "摘要查看";
          break;
        case "2":
          this.textView = "列表查看";
          break;
      }
    },
    //时间排序选择
    handleTime(val) {
      this.timeStatus = val;
      switch (val) {
        case "0":
          this.timeOrderby = "时间降序";
          this.currentOrder = "updatetime desc";
          this.pageIndexVal = 1;
          this.queryAgain();
          break;
        case "1":
          this.timeOrderby = "时间升序";
          this.currentOrder = "updatetime asc";
          this.pageIndexVal = 1;
          this.queryAgain();
          break;
        case "2":
          this.timeOrderby = "7天转载";
          break;
      }
    },
    openDetails(Boolean, articlesequenceid) {
      this.articleid = articlesequenceid;
      if (this.articleid != "") {
        let params = {
          id: this.articleid,
        };
        GetJfrbArticle(params)
          .then((res) => {
            this.articleInfo = res.data;
            this.getAnalysis(articlesequenceid);
          })
          .catch((err) => {
            console.warn(err);
          });
      }
      this.showDetail = true;
    },
    //关闭
    hadleBack() {
      this.showDetail = false;
    },
    load() {
      this.busy = true;
      this.loading = true;
      let emotion = {};
      if (this.formSearch.emotion == "-1") {
        emotion = null;
      } else if (this.formSearch.emotion == "51") {
        emotion = {
          from: 55.01 * 100,
          to:
            (this.formSearch.emotionValueP == 55
              ? "55.01"
              : this.formSearch.emotionValueP) * 100,
        };
      } else if (this.formSearch.emotion == "1") {
        emotion = {
          from: 1,
          to: this.formSearch.emotionValueN * 100,
        };
      } else if (this.formSearch.emotion == "50") {
        emotion = {
          from: 45.01 * 100,
          to: 55 * 100,
        };
      }
      let params = {
        keywords: [
          {
            field: this.formSearch.searchRange || "",
            word: this.formSearch.allKey,
            andOrNot: 0,
          },
          {
            field: this.formSearch.searchRange || "",
            word: this.formSearch.anyKey,
            andOrNot: 1,
          },
          {
            field: this.formSearch.searchRange || "",
            word: this.formSearch.exceptKey,
            andOrNot: 2,
          },
        ],
        date: {
          from: moment(this.formSearch.time[0]).format("YYYY-MM-DD"),
          to: moment(this.formSearch.time[1]).format("YYYY-MM-DD"),
        },
        contentWordsCount: this.formSearch.contentWordsCount || "",
        original: this.formSearch.original || null,
        hasvideo: this.formSearch.haveVideo || null,
        imageCount: this.formSearch.imageCount || null,
        classes: this.formSearch.classify || [],
        emotionList: this.formSearch.tagEmotion || [],
        emotionAnd: this.formSearch.tagEmotionIsAnd || false,
        groupArticletypes: this.formSearch.groupArticletypes || [],
        articletypes: this.formSearch.articletypes || [],
        emotion: emotion || null,
        // emotion: emotion, // 注意，测试字段先写死
        cityids: this.formSearch.cityids || [],
        sourceids: this.formSearch.sourceids || [],
        mediaids: this.formSearch.mediaids || [],
        customSourceIds: this.formSearch.customSourceIds || [],
        tags: this.formSearch.tags || [],
        industryTypeId: this.formSearch.industryTypeId || "0",
        markinfo: true,
        orderBy: this.currentOrder,
        pageIndex: this.pageIndexVal,
        pageSize: this.pageSizeVal,
      };
      let keysList = [];
      params.keywords.forEach((item, index) => {
        if (item.andOrNot != 2) {
          keysList.push(item.word);
        }
      });
      // this.$store.commit("template/SET_SEARCHKEYS", keysList);
      GetAdvanced(params)
        .then((res) => {
          // this.articleListData = res.data.rows;
          this.articleTotal = res.data.total;
          let list = res.data.rows;
          let _combineCount = 0;
          let itemIds = [];
          let sameItems = [];
          if (list != null) {
            for (let i = 0; i < list.length; i++) {
              //去除相似文章
              if (
                list[i].same_id === "" ||
                list[i].same_id == null ||
                itemIds.indexOf(list[i].same_id) == -1
              ) {
                itemIds.push(list[i].same_id); //相似文章列表对象
                this.articleListData.push(list[i]); //文章列表对象
              } else {
                sameItems.push(list[i].same_id); //相似文章列表对象
                _combineCount++;
              }
              this.updateCount = list.length;
              this.combineCount = _combineCount;
              this.similar = true;
              setTimeout(() => {
                this.similar = false;
              }, 2000);
            }
            this.articleListData = this.articleListData.map((v, index) => {
              if (v.same_id != null && sameItems.indexOf(v.same_id) >= 0) {
                v.isHasSimilar = false;
              } else {
                v.isHasSimilar = true;
              }
              return { ...v, showDetail: false, isClick: false };
            });
            // 如果请求回来的数据小于pageSize，则说明数据到底了。
            if (list.length < 20) {
              this.noMore = true; // 提示 已经到底部了
              this.busy = true;
            }
            // 避免数据总条数是start的倍数时，数据到底还会请求一次。
            else if (this.articleListData.length === res.data.total) {
              this.noMore = true;
            } else {
              this.busy = false;
              this.pageIndexVal++;
            }

            this.hot = false;
            this.loading = false;
          }
          if (this.$refs.articleList && this.articleListData.length > 0) {
            this.$refs.articleList.openDetails(
              this.articleListData[0].articlesequenceid,
              this.articleListData[0],
              0
            );
            this.getAnalysis(this.articleListData[0].articlesequenceid);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },

    // data-picker变化后重新获取文章列表
    queryAgain() {
      this.articleListData = [];
      setTimeout(() => {
        this.load();
      }, 100);
    },
  },
};
</script>
<style lang="scss" scoped>
.back-tool {
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--bg);
  padding: 0 10px;
  border-radius: 2px;
  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    i {
      width: 16px;
      height: 16px;
      display: block;
      margin-right: 5px;
    }
  }
}
.back {
  color: var(--text-3);
  font-size: 12px;
  &:hover {
    color: var(--text-link);
  }
}
.news-warp {
  .news-warp-tools {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    margin-top: 20px;
    .tag {
      color: #fff;
      background: var(--brand);
      border-radius: 4px;
      padding: 0 4px;
    }
    .el-range-editor--mini.el-input__inner {
      border: none;
      width: 200px;
    }
    .el-date-editor {
      padding-left: 0;
    }
    ::v-deep .el-range-separator {
      width: 30px;
    }
    ::v-deep .el-range__close-icon {
      display: none;
    }
    .el-icon--right {
      margin-left: 0;
    }
  }
}
.articleDetail {
  flex: 1;
  margin-left: 20px;
  background: #fff;
  border-radius: 8px;
}
.el-dropdown-link-style {
  font-size: 12px;
  cursor: pointer;
}
.fn-scrollbar {
  transition: background-color 0.3s ease-in-out;
  padding: 0 15px;
  &::-webkit-scrollbar {
    width: 6px;
  }
  /*定义滑块颜色、内阴影及圆角*/
  &::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background-color: rgba(144, 147, 153, 0);
    -webkit-box-shadow: inset 0 0 0 rgba(0, 0, 0, 0);
  }
  /*定义滚动条的轨道颜色、内阴影及圆角*/
  &::-webkit-scrollbar-track {
    border-radius: 6px;
    background-color: #fff;
    -webkit-box-shadow: inset 0 0 0 rgba(0, 0, 0, 0);
  }
  &:hover {
    &::-webkit-scrollbar-thumb {
      background-color: rgba(144, 147, 153, 0.3);
    }
  }
}
.timeRange {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(32, 45, 64, 0.45);
  // img {
  //   width: 16px;
  //   height: 16px;
  // }
  p {
    display: flex;
    align-items: center;
    span {
      display: inline-block;
      // margin-left: 10px;
    }
    .name {
      font-size: 20px;
      font-weight: 500;
      background: linear-gradient(
        241deg,
        rgb(16, 175, 237) 0,
        rgb(20, 69, 155) 100%
      );
      color: transparent;
      text-align: left;
      white-space: nowrap;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      display: inline-block;
      margin: 0 5px 0 0px;
    }
  }
}
//文章详情
.similarMerger {
  position: absolute;
  top: 55%;
  // left: 50%;
  // margin-left: -190px;
  width: 320px;
  box-sizing: border-box;
  border-radius: 4px;
  border-width: 1px;
  border-style: solid;
  color: #67c23a;
  background-color: #f0f9eb;
  border-color: #e1f3d8;
  padding: 15px 15px 15px 20px;
}
.sidePanel {
  height: 640px;
  background-color: #fff;
  position: sticky;
  top: 80px;
}
</style>
